export default __webpack_public_path__ + "d278fa2d4d157961bd1a73da9158c7ad.svg";